// src/hooks/currencies/useRestoreCurrency.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreCurrency } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

function useRestoreCurrency() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: restoreCurrencyMutation, isPending: isRestore } = useMutation({
        mutationFn: restoreCurrency,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
            toast.success(isArabic ? "تم استعادة العملة بنجاح" : "Currency restored successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في استعادة العملة" : "Failed to restore currency"));
        },
    });

    return { restoreCurrency: restoreCurrencyMutation, isRestore };
}

export default useRestoreCurrency;
